var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edgeclip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.201 59.537a29.275 29.275 0 01-3.293 1.472 31.83 31.83 0 01-11.218 2.018c-14.785 0-27.665-10.17-27.665-23.222a9.837 9.837 0 015.133-8.534c-13.373.563-16.81 14.499-16.81 22.663 0 23.085 21.276 25.426 25.86 25.426 2.471 0 6.199-.719 8.436-1.425l.41-.138A40.102 40.102 0 0073.863 61.3a1.25 1.25 0 00-1.663-1.762z",
    fill: "url(#edgepaint0linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M72.201 59.537a29.275 29.275 0 01-3.293 1.472 31.83 31.83 0 01-11.218 2.018c-14.785 0-27.665-10.17-27.665-23.222a9.837 9.837 0 015.133-8.534c-13.373.563-16.81 14.499-16.81 22.663 0 23.085 21.276 25.426 25.86 25.426 2.471 0 6.199-.719 8.436-1.425l.41-.138A40.102 40.102 0 0073.863 61.3a1.25 1.25 0 00-1.663-1.762z",
    fill: "url(#edgepaint1radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.037 75.435a24.748 24.748 0 01-7.106-6.668 25.223 25.223 0 019.227-37.496c.975-.459 2.64-1.29 4.856-1.25a10.11 10.11 0 018.027 4.063 9.96 9.96 0 011.988 5.83c0-.065 7.643-24.872-24.998-24.872C11.315 15.042.035 28.059.035 39.48a40.667 40.667 0 003.784 17.498 39.995 39.995 0 0048.864 20.97 23.607 23.607 0 01-19.617-2.5l-.028-.013z",
    fill: "url(#edgepaint2linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M33.037 75.435a24.748 24.748 0 01-7.106-6.668 25.223 25.223 0 019.227-37.496c.975-.459 2.64-1.29 4.856-1.25a10.11 10.11 0 018.027 4.063 9.96 9.96 0 011.988 5.83c0-.065 7.643-24.872-24.998-24.872C11.315 15.042.035 28.059.035 39.48a40.667 40.667 0 003.784 17.498 39.995 39.995 0 0048.864 20.97 23.607 23.607 0 01-19.617-2.5l-.028-.013z",
    fill: "url(#edgepaint3radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.598 46.514c-.253.328-1.031.78-1.031 1.768 0 .816.53 1.6 1.474 2.26 4.494 3.124 12.965 2.711 12.987 2.711a18.61 18.61 0 009.458-2.609 19.18 19.18 0 009.508-16.523c.081-7.002-2.5-11.658-3.543-13.72C69.83 7.449 55.538 0 39.996 0A39.995 39.995 0 000 39.433c.15-11.417 11.499-20.638 24.997-20.638 1.094 0 7.33.106 13.124 3.146 5.105 2.681 7.78 5.918 9.64 9.127 1.93 3.334 2.274 7.546 2.274 9.224s-.856 4.166-2.437 6.221z",
    fill: "url(#edgepaint4radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.598 46.514c-.253.328-1.031.78-1.031 1.768 0 .816.53 1.6 1.474 2.26 4.494 3.124 12.965 2.711 12.987 2.711a18.61 18.61 0 009.458-2.609 19.18 19.18 0 009.508-16.523c.081-7.002-2.5-11.658-3.543-13.72C69.83 7.449 55.538 0 39.996 0A39.995 39.995 0 000 39.433c.15-11.417 11.499-20.638 24.997-20.638 1.094 0 7.33.106 13.124 3.146 5.105 2.681 7.78 5.918 9.64 9.127 1.93 3.334 2.274 7.546 2.274 9.224s-.856 4.166-2.437 6.221z",
    fill: "url(#edgepaint5radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "edgepaint0linear",
    x1: 18.3479,
    y1: 55.3219,
    x2: 74.0729,
    y2: 55.3219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edgepaint1radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(29.8029 0 0 28.3127 49.126 55.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edgepaint2linear",
    x1: 47.7259,
    y1: 31.1495,
    x2: 12.9204,
    y2: 69.0609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edgepaint3radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-81.384 47.186 18.265) scale(44.8156 36.2065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edgepaint4radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.53008 63.25222 -134.71427 -5.38855 8.081 14.804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edgepaint5radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.51628 29.19869 -23.74435 6.92543 75.014 24.187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "edgeclip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H79.996V80H0z"
  })))));
};

export default __webpack_public_path__ + "static/media/edge.2034aca0.svg";
export { SvgComponent as ReactComponent };